import type { NextPage } from 'next'
import Link from 'next/link'
import ArrowIcon from '../../../components/svgIcons/Arrow1'

interface IProps {

}

const Component: NextPage<IProps> = () => {
  const companyName = process.env.COMPANY_NAME || process.env.NEXT_PUBLIC_COMPANY_NAME;
  const addressItmes = [
    '16508 경기도 수원시 영통구 도청로 30',
    '북부청사 11780 의정부시 청사로 1',
    '경기도 콜센터 031-120'
  ]
  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  }
  return (
    <div className='w-full min-w-[1200px] bg-footer-bg'>
      <div className='h-[75px] flex justify-center'>
        <div className='flex w-[1200px] min-w-[1200px] max-w-[1200px] items-center'>
        {/* <div className='flex w-[1125px] min-w-[1125px] max-w-[1125px] items-center ml-0 clg:w-[1200px] clg:min-w-[1200px] clg:max-w[1200px] clg:ml-[75px]'> */}
          <ul className='flex space-x-4'>
            {/* <li>
              <Link href="/terms/privacy">
                <a className='text-footer-secondary hover:text-white'>
                  개인정보처리방침
                </a>
              </Link>
            </li>
            <li>
              <span className='text-footer-secondary'>|</span>
            </li> */}
            <li>
              <a className='text-footer-secondary hover:text-white' rel="noopener noreferrer" href="https://www.gg.go.kr/contents/contents.do?ciIdx=416&menuId=1598" target="_blank">
                경기도민원실
              </a>
            </li>
          </ul>
        </div>
        <div className='clg:!relative' style={{position: 'initial'}}>
          <a className='w-[75px] h-[75px] absolute right-0 clg2:right-[-75px] cursor-pointer' onClick={() => scrollTop()}>
            <div className='bg-[#0051A3] text-white flex justify-center items-center h-full w-full'>
              <div className='flex flex-col items-center justify-center'>
                <ArrowIcon fill='#FFFFFF' direction='top' />
                <span className='pt-1'>
                  TOP
                </span>
              </div>
            </div>
          </a>
        </div>
      </div>
      {/* border: 0; border-top: 1px solid #f00; opacity: .1; */}
      <hr style={{border: 0, borderTop: '1px solid #FFF', opacity: 0.1}} />

      <div className='h-[145px] flex justify-center pt-9'>
        <div className='w-[1200px] min-w-[1200px] max-w-[1200px]'>
          <div className='space-x-1'>
            <a className='font-light text-footer-impact hover:text-white' rel="noopener noreferrer" href="https://www.gg.go.kr" target="_blank">
              경기도청
            </a>
            <span className='font-light text-footer-primary'>
              : 16508 경기도 수원시 영통구 도청로 30 / 북부청사 11780 의정부시 청사로 1 / 경기도 콜센터 <a href="tel:031-120">031-120</a>
              {/* {addressItmes.join(' / ')} */}
            </span>
          </div>
          <div>
            <span className='font-light text-footer-secondary'>
              &copy; {(companyName || '').toUpperCase()} All Rights Reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
